<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Downline</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item" v-if="$route.query.id">
                    Reseller
                  </li>
                  <li class="breadcrumb-item active">Downline</li>
                </ul>
              </div>
              <!-- <div class="col-auto float-right ml-auto">
                <router-link :to="'/subscriptions'" class="btn add-btn">
                  <i class="fa fa-shopping-cart"></i> Order
                </router-link>
              </div> -->
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  class="form-control floating"
                  v-model="serverParams.columnFilters.period"
                  type="month"
                />
                <label class="focus-label">Period</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <div class="input-group">
                  <input
                    class="form-control floating"
                    v-model="serverParams.columnFilters.downline_keywords"
                    type="text"
                    placeholder="Name, Email, Mobile Phone"
                  />
                  <label class="focus-label">Search</label>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-3" v-if="!$route.query.id" >
              <div class="form-group"> 
                <multiselect
                  :class="' '"
                  v-model="referral_id"
                  id="ajax"
                  label="member_name"
                  track-by="member_id"
                  :placeholder="''"
                  open-direction="bottom"
                  :custom-label="(val) => {
                    return val.member_name + ' (' + val.member_email + ')';
                  }"
                  :options="referralOptions"
                  :searchable="true"
                  :loading="isLoading"
                  :internal-search="false"
                  :multiple="false"
                  :close-on-select="true"
                  placeholder="Referral"
                  :options-limit="300"
                  :limit="3"
                  :limit-text="(count) => {
                    return `and ${count} more`;
                  }"
                  :max-height="600"
                  :show-no-results="true"
                  :hide-selected="false"
                  @search-change="asyncFind"
                  :show-labels="false"
                >
                  <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                      <span>{{ option.member_name+" ("+option.member_email+")" }}</span>
                      <span class="custom__remove" @click="remove(option)">❌</span>
                    </span>
                  </template>
                  <template slot="clear" slot-scope="props">
                    <div
                      class="multiselect__clear"
                      v-if="referral_id"
                      @mousedown.prevent.stop="referral_id = null"
                    ></div>
                  </template>
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
              </div>
            </div>
            <!-- <ModalFilter @clear="resetFilter" @searchData="() => {
              serverParams.more_search = true;
              searchData();
            }">
              <template>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-6">Period</label>
                    <input
                      class="form-control col-md-6"
                      v-model="serverParams.columnFilters.period"
                      type="month"
                    />
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-6">Search</label>
                    <input
                      class="form-control col-md-6"
                      v-model="serverParams.columnFilters.keywords"
                      type="text"
                      placeholder="Name, Email, Mobile Phone"
                    />
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-6">Online Status</label>
                    <select
                      class="form-control col-md-6"
                      v-model="serverParams.columnFilters.is_online_status"
                    >
                      <option value></option> 
                      <option value="online">Online</option>
                      <option value="offline">Offline</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-6">Feature</label>
                    <select
                      class="form-control col-md-6"
                      v-model="serverParams.columnFilters.feature"
                    >
                      <option value></option> 
                      <option value="not_yet_broadcast"
                        >Not Yet Broadcast</option
                      >
                      <option value="not_yet_chatbot">Not Yet Chatbot</option>
                      <option value="not_yet_ai_chatbot"
                        >Not Yet AI Chatbot</option
                      >
                      <option value="not_yet_birthday_greetings"
                        >Not Yet Birthday Greetings</option
                      >
                      <option value="not_yet_panen_kontak"
                        >Not Yet Panen Kontak</option
                      >
                      <option value="using_broadcast">Using Broadcast</option>
                      <option value="using_chatbot">Using Chatbot</option>
                      <option value="using_ai_chatbot">Using AI Chatbot</option>
                      <option value="using_birthday_greetings"
                        >Using Birthday Greetings</option
                      >
                      <option value="using_panen_kontak"
                        >Using Panen Kontak</option
                      >
                    </select>
                  </div>
                </div>
              </template>
            </ModalFilter> -->
            <div v-if="$route.query.id" class="col-sm-6 col-md-2">
              <a
                href="javascript:void(0)"
                @click.prevent="resetFilter"
                class="btn btn-secondary btn-block"
                >Clear Filter</a
              >
            </div>
            <div class="col-sm-6 col-md-3">
              <a
                href="javascript:void(0)"
                @click.prevent="searchData"
                class="btn btn-success btn-block"
                >Search</a
              >
            </div>
          </div>
          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center">#</th>
                      <th class="text-center" style="width:100px;">Name</th>
                      <th class="text-center">Email</th>
                      <th class="text-center">Mobile Phone</th>
                      <th class="text-center">Detail Referral</th>
                      <!-- <th class="text-center">Join Date</th>
                      <th class="text-center">Confirmed Date</th>
                      <th class="text-center">Status Confirmed</th> -->
                      <!-- <th>Action</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="6">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row, index) in rows" :key="index">
                        <td class="text-right">{{ row.number }}</td>
                        <td>{{ row.member_name }}</td>
                        <td>{{ row.member_email }}</td>
                        <td>{{ row.member_mobilephone }}</td>
                        <td>{{ row.referral_detail }}</td>
                        <!-- <td>
                          {{
                            $moment
                            .unix(row.member_join_datetime)
                              .format("YYYY-MM-DD HH:mm:ss")
                            }}
                        </td>
                        <td>{{ row.member_is_confirmed_datetime }}</td>
                        <td>
                          <span
                            :class="
                              row.member_is_confirmed_status == '1'
                                ? 'text text-success'
                                : 'text text-danger'
                            "
                            >{{
                              row.member_is_confirmed_status == "1"
                              ? "Active"
                              : "Not Confirmed"
                            }}</span
                          >
                        </td> -->
                      </tr>
                    </template>
                    <template v-if="loading">
                      <tr>
                        <td colspan="6">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length < 1 && !loading">
                      <tr>
                        <td colspan="5" class="text-center">-empty-</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select
                @change="onPerPageChange(serverParams.perPage)"
                autocomplete="off"
                name="perPageSelect"
                v-model="serverParams.perPage"
                style="width: 100px;"
                class="select-to-paginasi"
              >
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label"
                >of {{ totalRecords }} total records</span
              >
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a
                href="javascript:void(0)"
                @click="onPrevChange(parseInt(currentPage))"
                tabindex="0"
                class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }"
              >
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input
                style="width:100px;"
                min="1"
                type="number"
                v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))"
                class
              />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a
                href="javascript:void(0)"
                @click="onNextChange(parseInt(currentPage))"
                tabindex="0"
                class="footer__navigation__page-btn"
                :class="
                  'btn ' +
                    {
                      disabled:
                        parseInt(currentPage) + 1 >
                        Math.ceil(totalRecords / serverParams.perPage)
                    }
                "
              >
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import {
  convertUTCDatetimeToUnix,
  formatLocalDate,
  nFormatter,
  getCurrentMonth,
  formatDate,
  labelStatusMessage,
  getWhatsappNumberFromJid,
  formatPriceRupiah
} from "@/utils/helper";
import { Skeleton } from "vue-loading-skeleton";
import ModalFilter from "@/components/ModalFilter";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import Multiselect from "vue-multiselect";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    ModalFilter,
    Multiselect
  },
  data() {
    return {
      loading: false,
      rows: [],
      totalRecords: 0,
      referral_id:null,
      currentPage: 1,
      rowPage: 1,
      referralOptions: [],
      isLoading: false,
      serverParams: {
        columnFilters: {
          period: "",
          downline_keywords: "",
          referral_id: ""
        },
        page: 1,
        perPage: 20 // perPage
      }
    };
    //  isactive : true
  },
  watch:{
    referral_id(val){
      if(val){
        this.serverParams.columnFilters.referral_id = val.member_id;
      }else{
        this.serverParams.columnFilters.referral_id = "";
      }
    }
  },
  created() {
    const { id } = this.$route.query;
    if (id) {
      this.serverParams.columnFilters.referral_id = id;
    }
    this.asyncFind("");
    this.loadItems(); 
    this.currentPage = this.serverParams.page;
  },
  methods: {
    convertUTCDatetimeToUnix(value) {
      return convertUTCDatetimeToUnix(value);
    },
    formatPriceRupiah(value) {
      return formatPriceRupiah(value);
    },
    asyncFind(query) {
      this.isLoading = true; 
      let serverParams = {
        columnFilters: {
          keywords:query
        },
        page: 1,
        perPage: 20 // perPage
      }
      this.$store
        .dispatch("member/listReseller", serverParams)
        .then(response => {
          this.isLoading = false;
          this.referralOptions = response.data.data; 
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
      // ajaxFindCountry(query).then(response => {
      //   this.countries = response;
      //   this.isLoading = false;
      // });
    },
    
    formatLocalDate(value) {
      return formatLocalDate(value);
    },
    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },
    formatDate(value) {
      return formatDate(value);
    },
    getCurrentMonth() {
      return getCurrentMonth();
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    resetFilter() {
      this.serverParams.columnFilters = {
        period: "",
        downline_keywords: "",
        feature: "",
        is_online_status: "",
        license_phone_number: ""
      };
      if (this.$route.query.id) {
        this.$router.replace({
          query: null
        });
      }
      this.serverParams.more_search = false;
      this.searchData();
    },
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("member/listDownline", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          console.log(data.data);
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    
    // Multiselect
    // if ($("#customleave_select").length > 0) {
    //   $("#customleave_select").multiselect();
    // }
    // if ($("#edit_customleave_select").length > 0) {
    //   $("#edit_customleave_select").multiselect();
    // }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "summary_"
};
</script>



// WEBPACK FOOTER //
// src/views/member/downline.vue